import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type DeleteAnnotationVariables = {
  annotationId: string;
  tourId: string;
};

export const useDeleteAnnotationMutation = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: async ({ annotationId }: DeleteAnnotationVariables) => {
      const { data } = await authApi.delete(
        `/virtual-tour/annotation/${annotationId}`
      );
      return data;
    },
    onSuccess: (_, { tourId }) => {
      queryClient.invalidateQueries({
        queryKey: ["virtual-tour-annotations", tourId],
      });
    },
  });

  return result;
};
